'use strict';

var RulesReadonlyQuickDirective = function RulesReadonlyQuickDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmRulesReadonly',
    template: require('../templates/rules-readonly-quick.html')
  };
};
RulesReadonlyQuickDirective.$inject = [];
module.exports = RulesReadonlyQuickDirective;